import { render, staticRenderFns } from "./NuevoCobroModalComponent.vue?vue&type=template&id=4a905cb3&scoped=true&"
import script from "./NuevoCobroModalComponent.vue?vue&type=script&lang=js&"
export * from "./NuevoCobroModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./NuevoCobroModalComponent.vue?vue&type=style&index=0&id=4a905cb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a905cb3",
  null
  
)

export default component.exports